import { render, staticRenderFns } from "./auto-login.vue?vue&type=template&id=28f43bf0&scoped=true"
import script from "./auto-login.vue?vue&type=script&lang=js"
export * from "./auto-login.vue?vue&type=script&lang=js"
import style0 from "./auto-login.vue?vue&type=style&index=0&id=28f43bf0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28f43bf0",
  null
  
)

export default component.exports